<!--
 * @Author: your name
 * @Date: 2020-07-03 12:21:59
 * @LastEditTime: 2020-07-13 14:03:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \By56En\src\components\userCenter\public\workTable.vue
--> 
<template>
  <div v-show="curId.includes(list.CustomerID) || !onlyAssantPro"   style="background-color:#FFFAF2">
    <div v-for="(item,index) in list.Children" class="nextEle" :key="index"  >
      <div class="listTr " >
        <div class="listTd" style="width:16%;border-top:none">
          <template v-if="item.RightValue===1">
            <div class="clearance" v-for="count in item.Level" :class="count>2?(!isLast?'borL2 wid23':'wid23'):'' "   :key="count"></div>
            <div :class="onlyAssantPro?'assant':'win10Box'"></div>
          </template>
          <template v-if="item.RightValue===2">
            <div class="clearance"  v-for="count in item.Level-1"  :class="count>2?(!isLast?'borL2 wid23':'wid23'):'' "   :key="count"></div>
            <div class="user-level">
              <div class="user-top">
                <i class="fa fa-xdian dian"></i>
              </div>
              <div  class='user-bottom' :class="nextId.includes(item.CustomerID) && onlyAssantData?'isBorR':'' " ></div>
            </div>
          </template>
          <div class="Name">
            <div>
              <el-tip  :content="item.UserName"></el-tip>
            </div>
          </div>
          <div class="spread">
            <i v-if="item.Children.length" class="fa fa-xArrow" :class="nextId.includes(item.CustomerID)?'tran180':''"  @click="spreadOut(item)"></i>
          </div>
        </div>
        <div class="listTd" style="width:18.8%">
          <div >
            <el-tip  class="font12" :content="item.Mail"></el-tip>
          </div>
        </div>
        <div class="listTd" style="width:12.8%">
          <div>
            <el-tip  class="font12" :content="item.Position"></el-tip>
          </div>
        </div>
        <div class="listTd" style="width:14.8%"><span>{{item.RightValue === 1 ? 'Assistant' : 'User'}}</span></div>
        <div class="listTd" style="width:9.6%"><span>{{item.Status ? 'Enable' :  'Prohibit'}}</span></div>
        <div class="listTd"  style="width:28%">
          <a class="w68h24BtnL " @click="StatusChange(item)">{{item.Status ? 'Prohibit' : 'Enable'}}</a>
          <a class="lineBlueBtnMin "  @click="openEdit(item)">Edit</a>
          <a class="lineBlueBtnMin " @click="resetPassTip(item)">Reset password</a>
        </div>
      </div>
      <div class="listTr"  >
        <!-- 递归调用自己 -->
        <workTable :list="item"  v-if="isShowChild(item)" :assant="isNextAss" :onlyAssantPro="onlyAssantData" :curId="nextId" :isLast="index === list.Children.length-1" ></workTable>
      </div>
    </div>
  </div>
</template>
<script>
import { post, fetch } from "@/ask/axios";
import { elAlert,elConfirm } from '@/utils/bulletBox'
import bus from '@/ask/eventBus'
import ElTip from "@/components/userCenter/public/elTip";
export default {
  name: "workTable",
  components: {ElTip},
  props: {
    isLast:Boolean, //是否是最后一个元素 用于结尾
    list: Object, //当前元素  渲染时用当前元素的children
    assant:Array, //上级分发的助理
    curId:Array, //当前展开的id集合  需要传到下级进行判断是否展开
    onlyAssantPro: {
      type: Boolean,
      default: () => {
        return true;  // 默认true
      }
    },
  },
  data() {
    return {
      isNextAss:[], //分发给下级的助理
      nextId:[], //添加展开的id
      onlyAssantData:true,
    }
  },
  computed: {
    // 计算属性的 getter

  },
  created(){
    this.loopHandle()
  },
  methods:{
    // 是否展开  如果有助理 / 无children就不展开 
    isShowChild(item) {
      if(item.Children.length) {
        return true
      } else {
        if(this.isNextAss.length) {
          let isChild = this.isNextAss.filter((ele)=>{
            return item.CustomerID === ele.OwnerCustomerID
          })
          if(isChild.length) {
            this.onlyAssantData = false
            return true
          }
        } 
        return false
      }
    },
    // 将展开状态的id添加到数组去  如果有就删除
    spreadOut(item) {
      if(!this.nextId.length){
        this.nextId.push(item.CustomerID)
        return
      }
      for (let i = 0; i < this.nextId.length; i++) {
        if(this.nextId[i] == item.CustomerID){
          this.nextId.splice(i,1)
          return
        }
      }
      this.nextId.push(item.CustomerID)
    },
    loopHandle() {
      // 将不是当前的助理分发给子元素领取
      this.isNextAss = this.list.Children.filter((item)=>{
        return this.list.CustomerID !== item.OwnerCustomerID && item.RightValue === 1
      })
      //对分发的助理筛选出当前正确的 用于添加到当前的children
      let childAssant = this.assant.filter((item)=>{
        return this.list.CustomerID === item.OwnerCustomerID && item.RightValue === 1
      })
      //由于当前层的助理肯定不是自己这边的 删除掉助理 只保留用户
      this.list.Children = this.list.Children.filter((item)=>{
        return this.list.CustomerID === item.OwnerCustomerID || item.RightValue === 2
      })
      // 将筛选好的助理加入到当前的子元素
      this.list.Children.unshift(...childAssant) 
    },
    // 状态变更
    StatusChange(curItem) {
      let url = this.$api02 + '/api/EbayCustomer/WorkGroup/EditChildAccountStatus';
      let param = {
        CustomerId: curItem.CustomerID,
        Status: !curItem.Status,
      }
      post(url,param).then((res)=> {
        if(res.IsOK) {
          curItem.Status = !curItem.Status
          elAlert(this,"success")
        } else {
          elAlert(this,"fail")
        }
      })
    },
    openEdit(item) {
      bus.$emit('openEditAccount',item) //调用最外层的组件
    },
    resetPassTip(curItem) {
      let tip = `The password will be sent to the account mailbox, please confirm to reset the password?`
      elConfirm(this,tip).then(()=>{
        this.resetPass(curItem)
      }).catch(()=>{

      })
    },
    // 重置密码
    resetPass(curItem) {
      let url = this.$api02 + '/api/EbayCustomer/WorkGroup/WorkingGroupResetPwd';
      let param = {
        Email: curItem.Mail,
        CustomerID: curItem.CustomerID,
        RootCustomerID: curItem.RootCustomerID
      }
      post(url,param).then((res)=> {
        if(res.IsOK) {
          elAlert(this,"success")
        } else {
          elAlert(this,"fail")
        }
      })
    },
  }
};
</script>
<style scoped>
@import "../../../../assets/css/userCenterCss.css";
.accountList .tran180{transition: transform .2s ease-in-out;transform: rotate(180deg)}
.assistant{  width: 5px;  height: 40px;  display: inline-block;  vertical-align: bottom;  border-left: 2px solid #e5e5e5;}
.dian{position: absolute;right: -9px;top: 8px;color: #a4a4a4;font-size: 20px;}
.user-level{width: 33px;height: 40px;display: inline-block;vertical-align: top;box-sizing: border-box;}
.user-level .user-top{box-sizing: border-box;;width: 25px;position: relative;height: 20px;border-bottom: 2px solid #e5e5e5;border-left: 2px solid #e5e5e5;}
.user-level .user-bottom{width:25px;height: 20px;border-left: 2px solid #e5e5e5;box-sizing: border-box;}
.Nobor{ border: none !important;}
.listTd span{font-size: 12px;}
.Name{display: inline-block;width: 80px;overflow: hidden;font-size: 12px;text-overflow:ellipsis;white-space:nowrap}
.assant{width: 10px;display: inline-block;height: 40px;vertical-align: top;border-left: 2px solid #e5e5e5;box-sizing: border-box;}
.win10Box{width: 10px;display: inline-block;height: 40px;vertical-align: top;}
.clearance{    box-sizing: border-box;width: 15px;display: inline-block;height: 40px;vertical-align: top;}
.nextEle:last-child .user-bottom{ border-left:0px !important}
.borL2{border-left: 2px solid #e5e5e5;}
.spread{ display: inline-block; overflow: hidden; font-size: 16px; height: 40px; line-height: 35px; text-align: center; box-sizing: border-box; width: 20px;}
.isBorR{ border-right: 2px solid #e5e5e5;}
.fa-xArrow{ cursor: pointer;}
.wid23{width: 23px !important;}
</style>


// WEBPACK FOOTER //
// src/components/userCenter/public/basicInfo/recursionList.vue